import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-badminton-series',
  templateUrl: './badminton-series.component.html',
  styleUrls: ['./badminton-series.component.scss']
})
export class BadmintonSeriesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
